let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7AOpi")).then(() => parcelRequire('f2H9Y'));